/* Turning nav menu to open on hover instead of click */
const items = document.querySelectorAll(".header__inline-menu details");
const dropdownItems = document.querySelector(".mega-menu__content");
const header = document.querySelector(".header");

items.forEach((item) => {
  item.addEventListener("mouseenter", () => {
    item.setAttribute("open", true);
    header.classList.add("show");
  });
  const detailsChild = item.querySelector("summary");
  detailsChild.addEventListener("focus", () => {
    item.setAttribute("open", true);
  });
  item.addEventListener("mouseleave", () => {
    const megaMenuContent = item.querySelector("div.mega-menu__content");
    item.removeAttribute("open");

    // menu content not closing in Safari
    // this forces a reflow
    if (megaMenuContent) {
      void megaMenuContent.offsetHeight;
    }
    header.classList.remove("show");
  });
});

document.querySelectorAll('nav header-menu [id^="Details-"] summary').forEach((summary) => {
  summary.addEventListener("click", (event) => {
    const spanDataHref = event.currentTarget.querySelector("span").getAttribute("data-href");
    const nameOfCollection = spanDataHref?.split("/")[2];
    window.location.replace(`https://${window.location.host}/collections/${nameOfCollection}`);
  });
});
